<div class="is-flex is-align-items-center is-flex-direction-column">
  <div class="is-fullwidth is-flex is-justify-content-flex-start">
    <div
      class="is-flex options is-flex-direction-column is-justify-content-flex-start ml-4"
      [formGroup]="bankForm"
    >
      <button
        fino-button
        (click)="toggleChart()"
        [icon]="hideChart ? 'Analytics Bars' : 'Close'"
        class="mb-3"
      ></button>
      <button
        fino-button
        (click)="fetchTickets(organization, {})"
        class="mb-3"
        icon="Button Refresh Arrows"
        aria-label="Refresh"
      ></button>
      @if (hasTenants) {
        <div>
          @if (!showBankList) {
            <button
              fino-button
              (click)="toggleBankList()"
              class="mb-3"
              aria-label="Toggle bank list"
              icon="Saving Bank 1"
            ></button>
          }
          @if (showBankList) {
            <fino-select
              class="bank-select has-background-white-bis is-absolute"
              [items]="tenants()"
              label="Banken"
              #tenantSelect
              formControlName="bank"
              [searchable]="true"
              bindLabel="displayName"
            >
              <div *select-item="let tenant" (click)="selectBank(tenant)">
                <div>{{ tenant.displayName }}</div>
                <div class="is-size-7 has-text-grey">
                  {{ tenant.urlWithoutProtocol }}
                </div>
              </div>
            </fino-select>
          }
        </div>
      }
    </div>

    <div [hidden]="hideChart" class="is-fullwidth">
      <app-ticket-overview-chart
        [statistic]="statistic()"
        (legendClicked)="onLegendClick($event)"
      ></app-ticket-overview-chart>
    </div>
  </div>

  <form [formGroup]="searchForm" class="mt-5 mb-5 columns">
    <div class="column">
      <fino-input formControlName="keyword" class="search-input" label="Suchen"> </fino-input>
    </div>
    <div class="column">
      <fino-checkbox
        formControlName="showOnlyRemindersPaused"
        label="ticketOverview.remindersPaused"
      >
      </fino-checkbox>
      <fino-checkbox
        class="mt-2"
        formControlName="showOnlyOpenStandingOrders"
        label="ticketOverview.hasOpenStandingOrders"
      >
      </fino-checkbox>
    </div>
  </form>

  @let isLoading = loading();

  <app-ticket-table
    [isLoading]="isLoading"
    [sortOrder]="sortOrder"
    [filterProperty]="filterProperty"
    (sortByFieldEvent)="sortByField($event)"
    [tickets]="tickets()"
    [organization]="organization"
  ></app-ticket-table>

  @if (!hasTickets && !isLoading) {
    <div class="mb-4">
      <span translate>ticketOverview.noTicketsFound</span>
    </div>
  }

  @if (isLoading) {
    <fino-icon icon="Loading Half" class="has-text-primary loading-spinner is-spinning"></fino-icon>
  }

  @if (hasTickets && !isLoading) {
    <nav class="pagination is-rounded my-4" role="navigation" aria-label="pagination">
      <ul class="pagination-list">
        @if (currentPage() > 2) {
          <li (click)="goToPage(1)">
            <a class="pagination-link">1</a>
          </li>
        }
        @if (currentPage() > 2) {
          <li>
            <span class="pagination-ellipsis">&hellip;</span>
          </li>
        }
        @if (currentPage() > 1) {
          <li>
            <a class="pagination-link" (click)="previousPage()">{{ currentPage() - 1 }}</a>
          </li>
        }
        <li>
          <a class="pagination-link is-current">{{ currentPage() }}</a>
        </li>
        @if (currentPage() < lastPage - 1) {
          <li>
            <a class="pagination-link" (click)="nextPage()">{{ currentPage() + 1 }}</a>
          </li>
        }
        @if (currentPage() < lastPage - 1) {
          <li>
            <span class="pagination-ellipsis">&hellip;</span>
          </li>
        }
        @if (currentPage() < lastPage) {
          <li (click)="goToPage(lastPage)">
            <a class="pagination-link">{{ lastPage }} </a>
          </li>
        }
      </ul>
    </nav>
  }
</div>
